









import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductUnitsDto } from '@/api';

@Component
export default class UnitSelector extends Vue {
  @Prop({required: true})
  private units!: ProductUnitsDto;
  @Prop({required: true})
  private unit!: string;

  private get changeUnit(): string {
    return this.unit;
  }

  private set changeUnit(unit: string) {
    this.$emit('update:unit', unit);
  }
}
